import { render, staticRenderFns } from "./SpeakingFollow.vue?vue&type=template&id=abb0319a&scoped=true&"
import script from "./SpeakingFollow.vue?vue&type=script&lang=js&"
export * from "./SpeakingFollow.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingFollow.vue?vue&type=style&index=0&id=abb0319a&lang=scss&scoped=true&"
import style1 from "./SpeakingFollow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0319a",
  null
  
)

export default component.exports